import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-alipay-bank-account-index',
  template: ` <div class="inner-content position-relative"></div> `
})
export class AlipayBankAccountIndexComponent implements OnInit {
  public queryParams: { [key: string]: string };

  constructor(private router: Router, private route: ActivatedRoute) {
    this.queryParams = this.route.snapshot.queryParams;
  }

  /**页面初始化**/
  ngOnInit(): void {
    this.router.navigate(['/account-management/ali-pay'], {
      queryParams: this.queryParams
    });
  }
}
